module.exports = __webpack_public_path__ + "img/POBox.eb5c4be9.svg";